import axiosInstance from "./AxiosInstanceMain";

export const getUserActivityLogsApi = async (params = {}) => {
  const response = await axiosInstance.get("/admin/user-activity-logs", { params });
  return response.data;
};
